// src/types/assets.ts
function isAsset(obj) {
  return obj && typeof obj === "object" && "id" in obj && "type" in obj && "x" in obj && "y" in obj && "width" in obj && "height" in obj && ["image", "video", "text", "shape", "canvas", "svg"].includes(obj.type);
}
function isImageAsset(asset) {
  return asset.type === "image";
}
function isVideoAsset(asset) {
  return asset.type === "video";
}
function isTextAsset(asset) {
  return asset.type === "text";
}
function isShapeAsset(asset) {
  return asset.type === "shape";
}
function isCanvasAsset(asset) {
  return asset.type === "canvas" || asset.type === "svg";
}
function generateAssetId() {
  return `asset-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

export { generateAssetId, isAsset, isCanvasAsset, isImageAsset, isShapeAsset, isTextAsset, isVideoAsset };
//# sourceMappingURL=chunk-4B3W7KT2.js.map
//# sourceMappingURL=chunk-4B3W7KT2.js.map